import { useState } from "react";

const DEFAULT_INDUSTRIES = [
  "Energy (Oil, Gas, Renewables)",
  "Construction and Engineering",
  "Trading",
  "Property Development and Real Estate",
  "Finance, Banking, Investment",
  "Technology & IT Solutions",
  "Healthcare & Pharmaceuticals",
  "Retail & Consumer Goods",
  "Education & Academia",
  "Manufacturing & Industrial",
  "Utilities & Infrastructure",
  "Hospitality / Tourism",
  "Logistics & Transportation",
  "Environmental Services",
];

export default function IndustrySelector({ form, updateField }) {
  const selected = Array.isArray(form.Industry)
    ? (form.Industry[0] || "")
    : (form.Industry || "");

  const [adding, setAdding] = useState(false);
  const [custom, setCustom] = useState("");
  const [message, setMessage] = useState("");

  const selectIndustry = (industry) => {
    updateField("Industry", [industry]);
    setMessage("");
  };

  const addCustom = () => {
    if (!custom.trim()) {
      setMessage("Please enter an industry");
      return;
    }
    updateField("Industry", [custom.trim()]);
    setCustom("");
    setAdding(false);
    setMessage("Saved successfully ✅");
    setTimeout(() => setMessage(""), 2000);
  };

  const clearIndustry = () => {
    updateField("Industry", []);
    setMessage("");
  };

  return (
    <div className="rounded-xl border border-pink-400/20 bg-white/5 p-4">
      <p className="text-pink-300 text-sm font-semibold mb-3">
        Which Industry do you work in? We suggest being specific using the "add" option below. For eg "Electrical Equipment Industry" or "Hospitality - Facility Management
      </p>

      {/* ✅ only the list scrolls, never gets cut */}
      <div className="max-h-[38vh] overflow-y-auto pr-2">
        {/* ✅ mobile 1 col, tablet 2, desktop 3 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">
          {DEFAULT_INDUSTRIES.map((industry) => (
            <label
              key={industry}
              className="min-w-0 flex items-start gap-2 text-[13px] sm:text-sm text-white/85 leading-snug cursor-pointer hover:text-white"
            >
              <input
                type="radio"
                name="industry"
                className="mt-1 accent-pink-500 flex-shrink-0"
                checked={selected === industry}
                onChange={() => selectIndustry(industry)}
              />
              <span className="min-w-0 whitespace-normal break-words">
                {industry}
              </span>
            </label>
          ))}
        </div>
      </div>

      {!!selected && (
        <div className="mt-3 flex items-center justify-between bg-[#11111a] px-3 py-2 rounded border border-pink-400/30">
          <p className="text-xs text-pink-300 min-w-0">
            ✅ Selected: <span className="text-white break-words">{selected}</span>
          </p>

          <button
            onClick={clearIndustry}
            className="text-xs text-red-400 underline hover:text-red-300 ml-3 flex-shrink-0"
          >
            Clear
          </button>
        </div>
      )}

      {!adding && (
        <button
          className="mt-3 text-pink-400 underline text-sm"
          onClick={() => {
            setAdding(true);
            setMessage("");
          }}
        >
          + Add Industry
        </button>
      )}

      {adding && (
        <div className="mt-3">
          <input
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            placeholder="Enter industry"
            className="w-full p-2 bg-[#11111a] border border-pink-400/40 rounded text-sm"
          />

          <div className="flex gap-2 mt-2">
            <button
              onClick={addCustom}
              className="bg-pink-500 px-3 py-1 rounded text-black text-sm"
            >
              Add
            </button>

            <button
              onClick={() => {
                setAdding(false);
                setCustom("");
                setMessage("");
              }}
              className="bg-gray-600 px-3 py-1 rounded text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {message && (
        <p
          className={`text-sm mt-2 ${
            message.includes("Saved") ? "text-green-400" : "text-red-400"
          }`}
        >
          {message}
        </p>
      )}
    </div>
  );
}